@if (showSurvey && survey) {
  <div
    class="survey-banner"
    [attr.dir]="textDirection"
    [class.rtl]="textDirection === 'rtl'"
    [class.ltr]="textDirection === 'ltr'"
    >
    <div
      class="survey-container"
      [class.has-bg]="survey.backgroundImageUrl"
      [ngStyle]="getSurveyContainerStyle()"
      >
      @if (showThankYou) {
        <div class="survey-thanks-content">
          <div class="survey-thanks-icon">
            <img src="assets/icons/survey-thanks.svg" alt="" aria-hidden="true" />
          </div>
          <p class="survey-thanks-message">
            {{ translate('survey.thankYou') }}
          </p>
          <button type="button" class="survey-thanks-close-btn" (click)="closeSurvey()">
            {{ translate('survey.close') }}
          </button>
        </div>
      }
      @if (!showThankYou && getCurrentQuestion(); as question) {
        <div class="survey-content">
          <div class="survey-header">
            <div class="survey-question" [ngStyle]="getQuestionStyle(question)">
              {{ question.questionText }}
            </div>
            <button
              type="button"
              class="survey-close"
              (click)="closeSurvey()"
              [attr.aria-label]="translate('survey.close')"
              >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                >
                <path
                  d="M12 0.5H20C26.3513 0.5 31.5 5.64873 31.5 12V20C31.5 26.3513 26.3513 31.5 20 31.5H12C5.64873 31.5 0.5 26.3513 0.5 20V12C0.5 5.64873 5.64873 0.5 12 0.5Z"
                  stroke="#B4BFCB"
                  />
                  <path
                    d="M20.1875 13.2188L17.4062 16L20.1875 18.8125L20.9062 19.5L19.5 20.9375L18.7812 20.2188L16 17.4375L13.1875 20.2188L12.5 20.9375L11.0625 19.5L11.7812 18.8125L14.5625 16L11.7812 13.2188L11.0625 12.5L12.5 11.0938L13.1875 11.8125L16 14.5938L18.7812 11.8125L19.5 11.0938L20.9062 12.5L20.1875 13.2188Z"
                    fill="#0C3058"
                    />
                  </svg>
                </button>
              </div>
              @if (question.type === 'Open') {
                <div class="survey-input-wrapper">
                  <div class="survey-textarea-container">
                    <label
                      [attr.for]="'survey-answer-' + (question?.id || '')"
                      class="survey-textarea-label"
                      [class.has-value]="openAnswer && openAnswer.trim().length > 0"
                      [class.is-focused]="isTextareaFocused"
                      >
                      {{ translate('survey.answerPlaceholder') }}
                    </label>
                    <textarea
                      [id]="'survey-answer-' + (question?.id || '')"
                      class="survey-textarea"
                      [(ngModel)]="openAnswer"
                      (input)="onTextareaInput($event)"
                      (focus)="isTextareaFocused = true"
                      (blur)="isTextareaFocused = false"
                      rows="1"
                    ></textarea>
                  </div>
                </div>
              }
              @if (question.type === 'SingleChoice') {
                <div class="survey-options">
                  @for (option of question.options; track option) {
                    <label
                      class="survey-option-radio"
                      [attr.for]="'survey-single-' + question?.id + '-' + option.id"
                      [class.selected]="selectedSingleChoice === option.id"
                      >
                      <input
                        type="radio"
                        [id]="'survey-single-' + question?.id + '-' + option.id"
                        [name]="'question-' + question.id"
                        [value]="option.id"
                        [(ngModel)]="selectedSingleChoice"
                        />
                        <span class="radio-label">{{ option.optionText }}</span>
                      </label>
                    }
                  </div>
                }
                @if (question.type === 'MultipleChoice') {
                  <div class="survey-options">
                    @for (option of question.options; track option) {
                      <label
                        class="survey-option-checkbox"
                        [attr.for]="'survey-multi-' + question?.id + '-' + option.id"
                        [class.selected]="selectedMultipleChoices.has(option.id)"
                        >
                        <input
                          type="checkbox"
                          [id]="'survey-multi-' + question?.id + '-' + option.id"
                          [checked]="selectedMultipleChoices.has(option.id)"
                          (change)="toggleMultipleChoice(option.id)"
                          />
                          <span class="checkbox-label">{{ option.optionText }}</span>
                        </label>
                      }
                    </div>
                  }
                  @if (question.type === 'Slider' && question.slider) {
                    <div class="survey-slider-wrapper">
                      <div class="survey-slider-options">
                        @for (value of getSliderValues(question.slider); track value) {
                          <label
                            class="survey-slider-option"
                            [attr.for]="'survey-slider-' + question?.id + '-' + value"
                            [class.selected]="sliderValue === value"
                            >
                            <span class="slider-option-number">{{ value }}</span>
                            <input
                              type="radio"
                              [id]="'survey-slider-' + question?.id + '-' + value"
                              [name]="'slider-' + question.id"
                              [value]="value"
                              [checked]="sliderValue === value"
                              (change)="sliderValue = value"
                              />
                            </label>
                          }
                        </div>
                        <div class="survey-slider-labels">
                          <span class="slider-label-min"
                            >{{ question.slider.minValue }} = {{ question.slider.minLabel }}</span
                            >
                            <span class="slider-label-max"
                              >{{ question.slider.maxValue }} = {{ question.slider.maxLabel }}</span
                              >
                            </div>
                          </div>
                        }
                        <button
                          type="button"
                          class="survey-submit-btn"
                          [disabled]="!canProceed() || isSubmitting"
                          (click)="nextQuestion()"
                          >
                          @if (currentQuestionIndex < survey!.questions.length - 1) {
                            <span>
                              {{ translate('survey.next') }}
                            </span>
                          }
                          @if (currentQuestionIndex === survey!.questions.length - 1) {
                            <span>
                              {{ translate('survey.submit') }}
                            </span>
                          }
                        </button>
                        @if (survey.description) {
                          <div class="survey-info">
                            <div class="survey-info-icon">
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <circle cx="8" cy="8" r="7" fill="#0C3058" />
                                <text x="8" y="11" text-anchor="middle" fill="white" font-size="10" font-weight="bold">
                                  i
                                </text>
                              </svg>
                            </div>
                            <p class="survey-info-text">{{ survey.description }}</p>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
